
import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { inCommands } from '../../../concepts/commands/CommandRegistry';
import { PopoutWidget } from '../../canvas/workspace/widgets/WidgetInterface';
import { WidgetManager } from '../../canvas/workspace/widgets/WidgetManager';

export const gestureOpen = defineCommand(
    'gestureOpen',
    'Gestures: Open',
    (r) => {
        const gc = r.call(WidgetManager).get('gestures');
        if (!gc) return;
        const popout = gc.get('button') as PopoutWidget;
        popout.update({ open: true });
    }
);

export const inGesturesCommands = () => inCommands(
    gestureOpen,
);

